export default __webpack_public_path__ + "static/media/logo.ca4baae3.png";